<template>
  <v-card>
    <v-form @submit.prevent="submitEditSite()" ref="editSiteForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit'" :details="`${site.name} (${site.project.name})`"></dialog-header>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedSite.name"
              label="* Name"
              autofocus
              :loading="loading"
              :rules="nameRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedSite.contactEmail"
              label="Contact Email"
              :loading="loading"
              :rules="contactEmailRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="editedSite.contactPhone"
              label="Contact Phone"
              :loading="loading"
              :rules="contactPhoneRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Location" :rules="locationRules" v-model="editedSite.location"></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="$store.state.user.userAuthClass.name === 'Administrator'">
            <v-switch label="Request" v-model="editedSite.request" :disabled="!userAuthClass"></v-switch>
          </v-flex>
          <!-- <v-flex xs12 sm6 v-for="(field, i) in editSiteFields" :key=i >
            <v-text-field v-model="editedSite[field.model]" :label="field.label" :rules="field.rules"></v-text-field>
          </v-flex>-->
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import SiteService from '@/services/requests/siteService'

// MIXINS
import SiteValidation from '@/services/validation/siteValidation'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'

export default {
  mixins: [SiteValidation],
  components: {
    DialogHeader,
  },
  data() {
    return {
      editedSite: Object.assign({}, this.site),
      loading: false,
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      this.editedSite = Object.assign({}, this.site)
      this.close()
    },
    submitEditSite() {
      if (!this.$refs.editSiteForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.save()
    },
    save() {
      this.loading = true
      SiteService.updateSite(this.editedSite)
        .then((result) => {
          this.loading = false
          this.$store.commit('sites/updateArrayStateByValue', {
            prop: 'sites',
            value: this.site,
            editedValue: result.data.result.site,
          })
          this.editedSite = Object.assign({}, result.data.result.site)
          this.snack({ text: 'Site was edited!', color: 'green' })
          this.close()
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          this.snackError()
        })
    },
  },
  computed: {
    different() {
      if (!this._.isEqual(this.site, this.editedSite)) {
        return true
      } else {
        return false
      }
    },
  },
  props: {
    site: Object,
  },
}
</script>

<style>
</style>
